import { render, staticRenderFns } from "./ownerDetailRoom.vue?vue&type=template&id=4f8e71e5&scoped=true"
import script from "./ownerDetailRoom.vue?vue&type=script&lang=js"
export * from "./ownerDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailRoom.vue?vue&type=style&index=0&id=4f8e71e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e71e5",
  null
  
)

export default component.exports